import { createContext, ReactNode, useContext, useMemo } from "react";

interface ControlContext {
  readOnly?: boolean;
}

export const ControlContext = createContext<ControlContext>({});

export const useControlContext = () => {
  return useContext(ControlContext);
};

export const WritableControlContextProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const contextValue = useMemo(() => ({ readOnly: false }), []);
  return (
    <ControlContext.Provider value={contextValue}>
      {children}
    </ControlContext.Provider>
  );
};
